export const OFFICE_SECTION = '/?id=our-offices'
export const BUSINESS_SECTION = '/?id=businesses'
export const LEARNERS_SECTION = '/?id=learners'
export const GAMEDEVELOPERS_SECTION = '/?id=game-developers'
export const IBC_SECTION = '/?id=launch'
